
















import Vue from 'vue'
import {
  AccountingDto,
  AccountingAwardDto,
  FinalSettlementDto,
  FinalSettlementPositiveDto,
  FinalSettlementNegativeDto,
  DefinitiveWarrantyRefundDto,
  PaymentDTO,
  FirstPaymentDTO,
  SecondPaymentDTO
} from '@/Application/Expediente'
import AccountingAward from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/AccountingAward.vue'
import FinalSettlement from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/FinalSettlement.vue'
import FinalSettlementPositive
  from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/FinalSettlementPositive.vue'
import FinalSettlementNegative
  from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/FinalSettlementNegative.vue'
import DefinitiveWarrantyRefund
  from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/DefinitiveWarrantyRefund.vue'
import Payment from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/Payment.vue'
import FirstPayment from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/FirstPayment.vue'
import SecondPayment from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting/SecondPayment.vue'

interface Sections {
  award: AccountingAwardDto | null;
  final: FinalSettlementDto | null;
  positivo: FinalSettlementPositiveDto | null;
  negativo: FinalSettlementNegativeDto | null;
  definitivo: DefinitiveWarrantyRefundDto | null;
  payment: PaymentDTO |null;
  firstPayment: FirstPaymentDTO | null;
  secondPayment: SecondPaymentDTO | null
}

export default Vue.extend({
  name: 'Accounting',
  components: {
    AccountingAward,
    FinalSettlement,
    FinalSettlementPositive,
    FinalSettlementNegative,
    DefinitiveWarrantyRefund,
    Payment,
    FirstPayment,
    SecondPayment
  },
  props: {
    accounting: {
      type: AccountingDto || null,
      required: false
    }
  },
  data (): Sections {
    return {
      award: null,
      final: null,
      positivo: null,
      negativo: null,
      definitivo: null,
      payment: null,
      firstPayment: null,
      secondPayment: null
    }
  },
  computed: {
    hasSettlement (): boolean {
      return this.accounting !== null &&
        this.accounting.award !== null &&
        this.accounting.award.codModoAlleamentoDef === 'RESUL'
    },
    hasFractionedPayment (): boolean {
      return this.accounting !== null &&
        this.accounting.fraccionaPago
    },
    hasDamages (): boolean {
      return this.accounting !== null &&
        this.accounting.danos
    }
  },
  mounted () {
    if (this.accounting !== null) {
      this.award = this.accounting.award
      this.final = this.accounting.finalSettlement
      this.positivo = this.accounting.positiveFinalSettlement
      this.negativo = this.accounting.negativeFinalSettlement
      this.definitivo = this.accounting.definitiveWarrantyRefund
      this.payment = this.accounting.payment
      this.firstPayment = this.accounting.firstPayment
      this.secondPayment = this.accounting.secondPayment
    }
  }
})
